export const getFormattedStatus = (status: string) => {
  if (status === 'FIRM_ORDER') {
    return 'Firm Order';
  }

  const firstChar = status[0];
  const restChars = status.slice(1);

  return `${firstChar}${restChars.toLowerCase()}`;
};
